import { useEffect } from 'react';
import OrderManagement from '../../Pages/OrderManagement/OrderManagement.Page';
import { Route, Routes } from 'react-router-dom';
import OrderDetailsPage from '../../Pages/OrderDetails/OrderDetails.Page';
import { useDispatch } from 'react-redux';
import { fetchOrders } from '../../Features/orderManagementSlice';
import ReturnOrderDetails from '../../Pages/OrderManagement/ReturnOrder/ReturnOrderDetails';
import { OrdersManagementContextProvider } from '../../Context/OrdersManagementContext';

function OrderManagementRoute() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchOrders());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Routes>
            <Route 
                index 
                element={
                    <OrdersManagementContextProvider>
                        <OrderManagement />
                    </OrdersManagementContextProvider>
                } 
            />

            <Route path=':orderId' element={<OrderDetailsPage />} />
            <Route path='return-order/:orderId' element={<ReturnOrderDetails />} />
        </Routes>
    );
}

export default OrderManagementRoute;
